import { VoxelWorld } from '@vm/shared';
import { MATERIALS } from '../palette';
import { brickPlaza } from './brickPlaza';
import { MapBuilder } from './builder';
import { castleClash } from './castleClash';
import { craneYard } from './craneYard';
import { depotRun } from './depotRun';
import { duelPits } from './duelPits';
import { dustWorks } from './dustWorks';
import { cargoBox, cobbleRow, soukRun } from './tracedMaps';
import { pastelCourt } from './pastelCourt';
import { pumpkinHollow } from './pumpkinHollow';
import { seasideArcade } from './seasideArcade';
import { sunsetCruiser } from './sunsetCruiser';
import { gondolaPeak } from './gondolaPeak';
import { duneFort } from './duneFort';
import { frostbite } from './frostbite';
import { harvestFarm } from './harvestFarm';
import { neonRooftops } from './neonRooftops';
import { sunkenTemple } from './sunkenTemple';
import { trainingGrounds } from './training';
import { voxelIsland } from './voxelIsland';
import type { MapDef, MapMeta } from './types';

export * from './builder';
export * from './types';

export const MAP_LIST: MapDef[] = [brickPlaza, trainingGrounds, craneYard, frostbite, sunkenTemple, neonRooftops, castleClash, duneFort, duelPits, voxelIsland, harvestFarm, depotRun, dustWorks, cobbleRow, soukRun, cargoBox, pastelCourt, pumpkinHollow, seasideArcade, sunsetCruiser, gondolaPeak];

export const MAPS: Record<string, MapDef> = Object.fromEntries(MAP_LIST.map((m) => [m.id, m]));

export function registerMap(def: MapDef): void {
  if (!MAPS[def.id]) MAP_LIST.push(def);
  MAPS[def.id] = def;
}

export function getMap(id: string): MapDef {
  const m = MAPS[id];
  if (!m) throw new Error(`Unknown map ${id}`);
  return m;
}

export interface GeneratedMap {
  def: MapDef;
  world: VoxelWorld;
  meta: MapMeta;
  seed: number;
}

/** Deterministically builds a map. Identical output on server and every client. */
export function generateMap(id: string, seed?: number): GeneratedMap {
  const def = getMap(id);
  const s = seed ?? def.seed;
  const [sx, sy, sz] = def.size;
  const world = new VoxelWorld(sx, sy, sz, MATERIALS);
  world.track = false;
  const b = new MapBuilder(world, s);
  const meta = def.build(b);
  world.finishGeneration();
  return { def, world, meta, seed: s };
}
